import { Routes } from '@angular/router';

import { AuthGuard } from '@guards/auth.guard';
import { RoleGuard } from '@guards/role.guard';
import { DocDetailGuard } from '@guards/document-edit.guard';
import { UnsavedChangesGuard } from '@guards/unsaved-changes.guard';
import { AppPageComponent } from '@pages/app/app.page.component';
import { LoginPageComponent } from '@pages/login/login.page.component';
import { MainInboxPageComponent } from '@pages/main/inbox/main-inbox.page.component';
import { StationInboxPageComponent } from '@pages/station/inbox/station-inbox.page.component';
import { ErrorPageComponent } from '@pages/error/error.page.component';
import { Route } from '@constants/route';
import { UnsavedCorrectionsGuard } from '@guards/unsaved-corrections.guard';

const mainRoutes: Routes = [
    {
        path: Route.Inbox,
        component: MainInboxPageComponent,
        canActivate: [RoleGuard, AuthGuard],
        data: { navbarVisible: true },
    },
    {
        path: `${Route.Inbox}/:id`,
        redirectTo: `${Route.Inbox}/:id/discrepancies`,
        pathMatch: 'full',
    },
    {
        path: `${Route.Inbox}/:id`,
        loadComponent: () =>
            import('@pages/main/document-detail/document-detail.page.component').then(
                (m) => m.DocumentDetailPageComponent,
            ),
        canActivate: [RoleGuard, DocDetailGuard, AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        children: [
            {
                path: 'metadata',
                loadComponent: () =>
                    import('@pages/main/document-detail/metadata.page.component').then(
                        (m) => m.MetadataPageComponent,
                    ),
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: 'discrepancies',
                loadComponent: () =>
                    import('@pages/main/document-detail/discrepancies.page.component').then(
                        (m) => m.DiscrepanciesPageComponent,
                    ),
                children: [
                    {
                        path: ':discId',
                        loadComponent: () =>
                            import('@pages/main/document-detail/discrepancy-detail/discrepancy-detail.page.component').then(
                                (m) => m.DiscrepancyDetailPageComponent,
                            ),
                        canDeactivate: [UnsavedChangesGuard],
                    },
                ],
            },
            {
                path: 'wf-internals',
                loadComponent: () =>
                    import('@pages/main/document-detail/internals.page.component').then(
                        (m) => m.InternalsPageComponent,
                    ),
            },
        ],
    },
];

const stationRoutes: Routes = [
    {
        path: Route.StationInbox,
        component: StationInboxPageComponent,
        canActivate: [RoleGuard, AuthGuard],
        data: { navbarVisible: true },
    },
    {
        path: `${Route.StationInbox}/:id`,
        redirectTo: `${Route.StationInbox}/:id/discrepancies`,
        pathMatch: 'full',
    },
    {
        path: `${Route.StationInbox}/:id`,
        canActivate: [RoleGuard, AuthGuard],
        loadComponent: () =>
            import('@pages/station/document-detail/document-detail.page.component').then(
                (m) => m.StationDocumentDetailPageComponent,
            ),
        canDeactivate: [UnsavedCorrectionsGuard],
        children: [
            {
                path: 'discrepancies',
                loadComponent: () =>
                    import('@pages/station/document-detail/discrepancies.page.component').then(
                        (m) => m.DiscrepanciesPageComponent,
                    ),
            },
            {
                path: 'metadata',
                loadComponent: () =>
                    import('@pages/station/document-detail/metadata.page.component').then(
                        (m) => m.MetadataPageComponent,
                    ),
            },
            {
                path: 'comments',
                loadComponent: () =>
                    import('@pages/station/document-detail/comments.page.component').then(
                        (m) => m.CommentsPageComponent,
                    ),
            },
        ],
    },
];

const configurationRoutes: Routes = [
    {
        path: Route.Configuration,
        loadComponent: () =>
            import('@pages/configuration/configuration.page.component').then(
                (m) => m.ConfigurationPageComponent,
            ),
        canActivate: [RoleGuard, AuthGuard],
        data: { navbarVisible: true },
    },
    {
        path: `${Route.Configuration}/station/:id`,
        loadComponent: () =>
            import('@pages/configuration/station-detail/station-detail.page.component').then(
                (m) => m.StationDetailPageComponent,
            ),
        canActivate: [RoleGuard, AuthGuard],
    },
];

export const routes: Routes = [
    { path: Route.Login, component: LoginPageComponent },
    {
        path: Route.App,
        component: AppPageComponent,
        canActivate: [AuthGuard],
        data: { navbarVisible: true },
    },
    {
        path: Route.Error,
        component: ErrorPageComponent,
        data: { navbarVisible: true },
    },
    ...mainRoutes,
    ...stationRoutes,
    ...configurationRoutes,
    { path: '**', redirectTo: Route.App },
];
